"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramModalMobile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _components = require("./components");
var _mortgageLink = require("../../constants/mortgageLink");
var _utils = require("../../utils");
const _excluded = ["name", "showEscrow", "onClose", "onMortgageButtonClick", "escrowRate", "rate"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramModalMobile = _ref => {
  let {
      name,
      showEscrow,
      onClose,
      onMortgageButtonClick,
      escrowRate,
      rate
    } = _ref,
    selectedProgram = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_uiKit.ModalWindow, {
    open: true,
    title: `Программа ипотеки «${name}»`,
    fixed: true,
    width: 693,
    footer: /*#__PURE__*/React.createElement(_uiKit.LinkButton, {
      size: "L",
      theme: "fill_primary",
      fullWidth: true,
      href: _mortgageLink.MORTGAGE_LINK,
      onClick: () => onMortgageButtonClick(selectedProgram.id)
    }, "\u041F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043E\u043D\u043B\u0430\u0439\u043D"),
    onClose: onClose,
    content: /*#__PURE__*/React.createElement(_components.ProgramContent, (0, _extends2.default)({}, selectedProgram, {
      rate: (0, _utils.getRate)({
        showEscrow,
        escrowRate,
        rate
      })
    }))
  });
};
exports.ProgramModalMobile = ProgramModalMobile;